export default __webpack_public_path__ + "static/media/Mysore_Tipu's gumbaj_1.ce16b57d.jpg";